export default __webpack_public_path__ + "static/locations-d6f4aec37710d0df88c5e7910b47fa7b.png";